module.exports = __webpack_public_path__ + "img/151.60923b41.jpg";